import { useTranslation } from 'react-i18next';

export interface IErrorMessage {
  [fieldName: string]: {
    [errorType: string]: string;
  };
}

interface IErrorParams {
  errors: any;
  fieldName: string;
  errorMessages: IErrorMessage;
  validationRules?: Record<string, number>;
}

export function useErrorMessage() {
  const { t } = useTranslation();

  return ({
    errors,
    fieldName,
    errorMessages,
    validationRules
  }: IErrorParams): string => {
    const error = errors?.[fieldName];
    const errorType = error?.type;

    if (!errorType) return '';

    const customErrorMessage = errorMessages?.[fieldName]?.[errorType];

    const requiredLength = validationRules?.[errorType];

    return t(customErrorMessage || `validation_${fieldName}_${errorType}`, {
      requiredLength
    });
  };
}
